import { KeyRound, ShieldCheck, CalendarClock } from "lucide-react";
import { Reveal } from "./Reveal";

const CHAPTERS = [
    {
        number: "01",
        icon: KeyRound,
        title: "Join the club",
        body: "One $399 membership, paid securely by card. No subscriptions, no hidden fees, no financing games. Your seat in the allocation pool is locked the moment your payment lands.",
    },
    {
        number: "02",
        icon: ShieldCheck,
        title: "We allocate",
        body: "We reserve a factory-fresh 2026 RAV4 allocation in your name — your trim, your color. Allocation is guaranteed within 90 days of your membership payment — or we provide a full and complete refund.",
    },
    {
        number: "03",
        icon: CalendarClock,
        title: "You drive",
        body: "Complete your purchase through a partner dealer below Total Suggested Retail Price — and yes, that total stays under sticker even after our $399 fee. No markups, no bidding wars.",
    },
];

export const Manifesto = () => (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-28 sm:py-36">
        <div className="mx-auto max-w-7xl px-6">
            <Reveal>
                <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.35em] text-[#2563EB]">
                    <span className="h-2 w-2 rotate-45 bg-[#2563EB]" aria-hidden="true" />
                    The manifesto
                </p>
                <h2 className="max-w-3xl font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-tighter sm:text-5xl">
                    Buying a car shouldn't feel like a fight.
                </h2>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400 md:text-lg">
                    Dealers mark up. Waitlists stretch for months. We built the club so members
                    skip all of it — three chapters, one outcome.
                </p>
            </Reveal>

            <div className="mt-20 grid grid-cols-1 gap-px bg-white/10 md:grid-cols-3">
                {CHAPTERS.map((chapter, i) => (
                    <Reveal key={chapter.number} delay={i * 0.12} className="bg-[#050505]">
                        <article
                            data-testid={`chapter-${chapter.number}`}
                            className="group flex h-full flex-col p-8 transition-colors duration-500 hover:bg-[#0c0c0c]"
                        >
                            <div className="flex items-start justify-between">
                                <span className="font-display text-6xl font-extrabold tracking-tighter text-white/10 transition-colors duration-500 group-hover:text-[#2563EB]/40">
                                    {chapter.number}
                                </span>
                                <chapter.icon className="h-6 w-6 text-[#2563EB]" aria-hidden="true" />
                            </div>
                            <h3 className="mt-10 font-display text-2xl font-bold uppercase tracking-tight sm:text-3xl">
                                {chapter.title}
                            </h3>
                            <p className="mt-4 text-sm leading-relaxed text-zinc-400 sm:text-base">
                                {chapter.body}
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
